export default function Footer() {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#contact';
    }
  };

  return (
    <footer className="bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* 会社情報 */}
          <div>
            <div className="mb-8">
              <img 
                src="https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/b47aa0060d508a8fee7fb7f43f1bd082.png" 
                alt="ソトマゴ" 
                className="h-12 w-auto mb-3"
              />
              <p className="text-base text-gray-600 font-medium">あなたの「やりたい」を実現します</p>
            </div>
            <div className="space-y-4 text-sm text-gray-700">
              <p className="flex items-start group">
                <i className="ri-map-pin-line mr-3 mt-1 flex-shrink-0 text-brand-yellow text-lg"></i>
                <span className="leading-relaxed">〒680-0035<br />鳥取県鳥取市新町214</span>
              </p>
              <p className="flex items-center group">
                <i className="ri-phone-line mr-3 flex-shrink-0 text-brand-yellow text-lg"></i>
                <a href="tel:+817090045641" className="hover:text-brand-yellow transition-colors duration-300 font-medium">070-9004-5641</a>
              </p>
              <p className="flex items-center group">
                <i className="ri-time-line mr-3 flex-shrink-0 text-brand-yellow text-lg"></i>
                <span className="leading-relaxed">
                  <strong className="text-brand-dark">24時間対応</strong><br />
                  <span className="text-xs text-gray-600">受付時間：9:00〜18:00</span>
                </span>
              </p>
            </div>
          </div>

          {/* Map Link */}
          <div>
            <h4 className="text-xl font-bold text-brand-dark mb-6">
              アクセス
            </h4>
            <a
              href="https://maps.google.com/?q=鳥取県鳥取市新町214"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-brand-dark hover:text-brand-yellow transition-all duration-300 cursor-pointer font-medium group"
            >
              <i className="ri-map-pin-line mr-2 text-lg group-hover:scale-110 transition-transform duration-300"></i>
              Google Mapで見る
            </a>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-xl font-bold text-brand-dark mb-6">
              <a href="#legal" className="hover:text-brand-yellow transition-colors duration-300">
                法的事項
              </a>
            </h4>
            <div className="space-y-3">
              <a href="/legal" className="block text-gray-600 hover:text-brand-yellow transition-all duration-300 cursor-pointer font-medium hover:translate-x-1">
                特定商取引法に基づく表記
              </a>
              <a href="/privacy" className="block text-gray-600 hover:text-brand-yellow transition-all duration-300 cursor-pointer font-medium hover:translate-x-1">
                プライバシーポリシー
              </a>
            </div>
          </div>
        </div>

        {/* Final CTAs */}
        <div className="text-center mb-12">
          <div className="flex flex-col sm:flex-row justify-center gap-5">
            <a
              href="tel:+817090045641"
              className="bg-brand-yellow text-brand-dark px-10 py-4 rounded-2xl font-bold hover:bg-brand-yellow-dark transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl hover:scale-105"
            >
              <i className="ri-phone-line mr-2"></i>
              電話する
            </a>
            <a
              href="https://line.me/R/ti/p/@251xqjgz?_gl=1*8soeuu*_gcl_au*MTUyNTMzMzgwOC4xNzU5NzQyMTgz*_ga*NjgyMTMyNjIuMTc1OTc0MjE4NA..*_ga_0PV16Y9CZG*czE3NjQ3NTgwMzUkbzIkZzAkdDE3NjQ3NTgwNDEkajU0JGwwJGgw"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-[#00B900] px-10 py-4 rounded-2xl font-bold border-2 border-[#00B900] hover:bg-[#00B900]/10 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl hover:scale-105"
            >
              <i className="ri-message-line mr-2"></i>
              LINEで相談
            </a>
            <button
              onClick={scrollToContact}
              className="bg-brand-dark text-white px-10 py-4 rounded-2xl font-bold hover:bg-brand-dark/90 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl hover:scale-105"
            >
              予約する
            </button>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-brand-yellow/20 pt-8 text-center">
          <p className="text-gray-600 text-sm font-medium">
            © 2024 ソトマゴ. All rights reserved. | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ml-1 hover:text-brand-yellow transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
